// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"271":"c1872c8e","318":"3b061401","415":"ddd1e48a","752":"3e32298b","775":"eb0df6f6"}[chunkId] + ".chunk.css";
};